import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { listItemStyle, textFieldStyle } from '../../../utils/consts/styles';

const SPECIALTY_DIRECTIONS = [
  'Экономический',
  'Инженерный',
  'Гуманитарный',
  'Медбио',
  'Естественнонаучный',
];

export default function SpecialtyDirectionSelect({ defaultValue = '', disabled = false }) {
  const [value, setValue] = useState(defaultValue);

  const isLegacy = defaultValue && !SPECIALTY_DIRECTIONS.includes(defaultValue);

  // Programmatic children array — avoids `false` values from `&&` landing in MUI Select's
  // children iteration, which crashes on child.props.value === undefined in v5.8
  const menuItems = [];
  if (isLegacy) {
    menuItems.push(
      <MenuItem sx={textFieldStyle} key="__legacy__" value={defaultValue} disabled>
        <span style={listItemStyle}>{defaultValue}</span>
      </MenuItem>
    );
  }
  SPECIALTY_DIRECTIONS.forEach((dir) => {
    menuItems.push(
      <MenuItem sx={textFieldStyle} key={dir} value={dir}>
        <span style={listItemStyle}>{dir}</span>
      </MenuItem>
    );
  });

  return (
    /*
     * maxWidth обязателен. Колонка карточки (.column_style_contract) — флекс без
     * заданной ширины, поэтому она растягивается под содержимое. Это одно
     * из двух полей карточки без фиксированной ширины, и длинное значение растягивало
     * всю колонку, ломая карточку. 325px — ширина соседних полей.
     */
    <div title={value} style={{ position: 'relative', display: 'inline-block', width: '100%', maxWidth: '325px' }}>
      <TextField
        label="Направление подготовки (специальность)"
        name="specialty_direction"
        type="text"
        variant="outlined"
        color="warning"
        margin="normal"
        size="small"
        select
        disabled={disabled}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        inputProps={textFieldStyle}
        InputLabelProps={textFieldStyle}
        sx={{ width: '100%' }}
      >
        {menuItems}
      </TextField>
      {!disabled && value && (
        <IconButton
          size="small"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setValue('');
          }}
          sx={{
            position: 'absolute',
            right: 28,
            top: '55%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          }}
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
}
